// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chaining_management_service_list_title{display:flex}", "",{"version":3,"sources":["webpack://./modules/chaining/vue/Components/ChainingManagementServiceList/ChainingManagementServiceList.scss"],"names":[],"mappings":"AAAA,wCACE,YAAA","sourcesContent":[".chaining_management_service_list_title {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
